import { FC, ReactElement } from "react"
import { FieldArray, FormikProps } from "formik" // eslint-disable-line

import { TenantColorsData } from "../../../types/api"
import { InputColor } from "../../inputs/InputColor"
import { ToolTip } from "../components/ToolTip"

export const TitleDividersGradientFields: FC = (): ReactElement => (
  <FieldArray
    name="gradient.titleDividersGradient"
    render={({ form }) => (
      <div className="mt-10 relative group">
        <ToolTip text="These are the gradient colors for the horizontal lines on the sides of the titles on some pages" />
        <h4>Gradient colors: title dividers</h4>
        {(form as FormikProps<TenantColorsData>).values.gradient.titleDividersGradient.map((_, index) => (
          <div key={index} className="flex items-end">
            <span className="mr-3">{index + 1}</span>
            <InputColor
              name={`gradient.titleDividersGradient.${index}`}
              value={(form as FormikProps<TenantColorsData>).values.gradient.titleDividersGradient[index]}
              onChange={(value: string) => form.setFieldValue(`gradient.titleDividersGradient.${index}`, value)}
            />
          </div>
        ))}
      </div>
    )}
  />
)
